import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomModalComponent } from '../___COMPONENTS/__common/bottom-modal/bottom-modal.component';

@Injectable({
  providedIn: 'root'
})
export class BottomModalProviderService {

  constructor(private _bottomSheet: MatBottomSheet) { }

  openBottomSheet(): void {
    this._bottomSheet.open(BottomModalComponent);
  }
}
